/* ==========================================================================
   JOINT FLEX — TSL  (advertorial rebuild)
   Upload as a theme asset named exactly: jf-tsl.js

   Two jobs only: run the offer blocks, and run the phone sticky bar.
   No carousel, no lightbox, no scroll animation — if this file grows past
   that, the page is drifting back toward being a magazine.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('jf');
  if (!root) return;

  /* ------------------------------------------------------------------
     PRICING + IDS — the only block you should need to edit.
       sub / once  = full charge for the pack
       bottles     = divisor for the per-bottle figure shown on the card
       days        = supply length, drives the per-day figure
       every       = renewal cadence, printed on the tile
     Per-bottle only on this page; the order total appears in the cart.
     ------------------------------------------------------------------ */
  var PRICING = {
    '1': { bottles:1, days:30,  every:'month',    sub:53.99,  once:59.99,  variant:'47590081265854', plan:'15569387710' },
    '3': { bottles:3, days:90,  every:'3 months', sub:131.97, once:164.97, variant:'47590081298622', plan:'15569486014' },
    '6': { bottles:6, days:180, every:'6 months', sub:209.94, once:299.94, variant:'47590081331390', plan:'15569518782' }
  };

  /* Second line of the phone sticky bar. Keep this true — a rolling low-stock
     claim in a bar that follows the reader down the page is the pattern
     regulators look at. "Ships today" is stronger if fulfilment supports it. */
  var FEATURED = '3';

  var subscribe = true;
  var busy = false;

  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var money = function (v) { return '$' + Number(v).toFixed(2); };

  /* ==================================================================
     TRACKING PASS-THROUGH
     Shopify records the landing URL for its own attribution, but that is
     the FIRST page of the session and it never reaches the order record in
     a form you can read in the admin. These params are captured on load,
     kept for the session, and written to the cart as attributes at add-to-
     cart, so they appear on the order under "Additional details".
     Add or remove keys here — nothing else needs to change.
     ================================================================== */
  var TRACK_KEYS = ['utm_source','utm_medium','utm_campaign','utm_content',
                    'utm_term','utm_id','subid','gclid','fbclid','msclkid'];
  var TRACK_STORE = 'jfTrack';

  function captureTracking() {
    var out = {};
    try { out = JSON.parse(sessionStorage.getItem(TRACK_STORE)) || {}; }
    catch (e) { out = {}; }

    try {
      var q = window.location.search;
      if (q && q.length > 1) {
        q.replace(/^\?/, '').split('&').forEach(function (pair) {
          if (!pair) return;
          var i = pair.indexOf('=');
          var k = decodeURIComponent(i < 0 ? pair : pair.slice(0, i));
          var v = i < 0 ? '' : decodeURIComponent(pair.slice(i + 1).replace(/\+/g, ' '));
          /* first touch wins — a later pageview without params can't wipe it */
          if (v && TRACK_KEYS.indexOf(k) !== -1 && !out[k]) out[k] = v.slice(0, 200);
        });
        sessionStorage.setItem(TRACK_STORE, JSON.stringify(out));
      }
    } catch (e) { console.warn('Joint Flex: could not read tracking params', e); }

    return out;
  }

  var TRACKING = captureTracking();

  var offers = $$('[data-offer]');
  if (!offers.length) return;

  var mbar     = root.querySelector('[data-mbar]');
  var mbarLine = root.querySelector('[data-mbar-line]');

  /* ==================================================================
     RENDER — every offer block on the page stays in sync
     ================================================================== */
  function render() {
    offers.forEach(function (offer) {
      $$('.tier', offer).forEach(function (t) {
        var d = PRICING[t.dataset.qty];
        if (!d) return;

        var total = subscribe ? d.sub : d.once;
        var each  = total / d.bottles;

        t.querySelector('[data-now]').textContent = money(each);
        t.querySelector('[data-day]').textContent = '$' + (total / d.days).toFixed(2) + ' per day';
        t.querySelector('[data-was]').textContent = subscribe ? money(d.once / d.bottles) : '';

      });

      var btn = offer.querySelector('[data-sub]');
      if (btn) btn.setAttribute('aria-checked', subscribe ? 'true' : 'false');

      /* the "as low as" figure follows the toggle, and is always the cheapest
         per-day across the three packs rather than a hardcoded number */
      var low = offer.querySelector('[data-low]');
      if (low) {
        var best = Math.min.apply(null, Object.keys(PRICING).map(function (k) {
          var x = PRICING[k];
          return (subscribe ? x.sub : x.once) / x.days;
        }));
        low.textContent = '$' + best.toFixed(2);
      }

      var note = offer.querySelector('[data-subnote]');
      if (note) {
        note.textContent = subscribe
          ? 'Subscriptions unlock up to 30% off your price. Your first order ships now. Skip, pause, or cancel anytime.'
          : 'One-time purchase \u2014 no refills. Turn this on to save up to 30%.';
      }
    });

    if (mbarLine) {
      var f = PRICING[FEATURED];
      var e = (subscribe ? f.sub : f.once) / f.bottles;
      mbarLine.textContent = f.bottles + ' bottles \u00b7 ' + money(e) + ' per bottle';
    }
  }

  /* ==================================================================
     CART
     ================================================================== */
  var OURS = Object.keys(PRICING).map(function (k) { return String(PRICING[k].variant); });

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw d; });
      return r.json();
    });
  }

  /* Remove only our own lines, so someone who backs out of checkout and picks
     a different pack replaces their choice instead of buying both. Other
     products in the cart are left alone, and a failure here never blocks the
     sale — a stale line costs less than a lost order. */
  function clearOurs(base) {
    return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var updates = {};
        cart.items.forEach(function (line) {
          if (OURS.indexOf(String(line.variant_id)) !== -1) updates[line.key] = 0;
        });
        if (!Object.keys(updates).length) return;
        return post(base + 'cart/update.js', { updates: updates });
      })
      .catch(function (e) { console.warn('Joint Flex: could not clear previous selection', e); });
  }

  function setBusy(on, clicked) {
    busy = on;
    $$('.tier').forEach(function (t) {
      t.disabled = on;
      var go = t.querySelector('[data-go]');
      if (go) go.textContent = (t === clicked && on) ? 'Adding\u2026' : 'Add to Cart';
    });
  }

  function fail(offer, msg) {
    var el = offer.querySelector('[data-err]');
    if (!el) return;
    el.hidden = false;
    el.textContent = msg || 'We couldn\u2019t add that to your cart. Please try again.';
  }

  function buy(tier, offer) {
    if (busy) return;
    var d = PRICING[tier.dataset.qty];
    if (!d || !d.variant) { fail(offer, 'That option isn\u2019t available right now.'); return; }

    var err = offer.querySelector('[data-err]');
    if (err) err.hidden = true;
    setBusy(true, tier);

    var item = { id: Number(d.variant), quantity: 1 };
    if (subscribe && d.plan) item.selling_plan = Number(d.plan);
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    clearOurs(base)
      .then(function () { return post(base + 'cart/add.js', { items: [item] }); })
      .then(function () {
        /* Cart attributes land on the order in the Shopify admin. This step
           is best-effort: a failure here must never cost the sale, so it
           always resolves. */
        if (!TRACKING || !Object.keys(TRACKING).length) return;
        return post(base + 'cart/update.js', { attributes: TRACKING })
          .catch(function (e) { console.warn('Joint Flex: tracking not saved', e); });
      })
      .then(function () { window.location.href = base + 'checkout'; })
      .catch(function (e) {
        console.error(e);
        fail(offer, e && e.description ? e.description : null);
        setBusy(false, tier);
      });
  }

  offers.forEach(function (offer) {
    $$('.tier', offer).forEach(function (t) {
      t.addEventListener('click', function () { buy(t, offer); });
    });
    var sub = offer.querySelector('[data-sub]');
    if (sub) sub.addEventListener('click', function () { subscribe = !subscribe; render(); });
  });

  render();

  /* ==================================================================
     STICKY BAR — phones only (CSS hides it above 760px)
     Appears once the reader passes the first offer block's cue and hides
     again over the offer blocks themselves. Session-only dismissal.
     ================================================================== */
  (function () {
    if (!mbar || !('IntersectionObserver' in window)) return;

    /* the "That's when I found Joint Flex" beat — the point the product first
       exists in the story. Earlier than that a buy bar reads as a banner
       stapled to an article. */
    var cue = null;
    $$('.beat').forEach(function (el) {
      if (!cue && /found Joint Flex/.test(el.textContent)) cue = el;
    });
    if (!cue) return;

    var KEY = 'jfTslBar';
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch (e) { /* private mode */ }
    if (dismissed) return;

    mbar.hidden = false;

    var past = false, atOffer = false;
    function sync() { mbar.classList.toggle('is-on', past && !atOffer && !dismissed); }

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      /* only once the cue has scrolled off the TOP, not while it's still
         below the fold on the way down */
      past = !e.isIntersecting && e.boundingClientRect.top < 0;
      sync();
    }, { threshold: 0 }).observe(cue);

    /* no point covering an offer block with a button that scrolls to it */
    var io = new IntersectionObserver(function (entries) {
      atOffer = entries.some(function (e) { return e.isIntersecting; });
      sync();
    }, { threshold: 0 });
    offers.forEach(function (o) { io.observe(o); });

    var x = root.querySelector('[data-mbar-close]');
    if (x) {
      x.addEventListener('click', function () {
        dismissed = true;
        mbar.classList.remove('is-on');
        try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* no-op */ }
      });
    }
  })();

  /* smooth scroll from the sticky bar to the first offer block */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  $$('a[href="#offer"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.getElementById('offer');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

})();
